import React from "react";
import { Box, Typography } from "@mui/material";
import { ChevronRight, Circle } from "@mui/icons-material";
import theme from "@/utils/theme";
import { TestResultStatusEnum } from "@/domain/enrollment.enum";
import { TestResultAlert } from "@/domain/alerts.interface";
import { useNavigate } from "react-router-dom";

type Request = {
  alert: TestResultAlert;
  handleMarkAlertAsViewed?: () => void;
  refetchAlerts: () => void;
};

const ApprovalRequestItem: React.FC<Request> = ({ alert }) => {
  const navigate = useNavigate();
  const alertClickHandler = (participantId: string) => {
    navigate(`/participants/${participantId}`);
  };

  const getBorderColorBasedOnAlertCode = () => {
    switch (alert.status) {
      case TestResultStatusEnum.NEGATIVE:
        return theme.palette.warning.light;
      case TestResultStatusEnum.POSITIVE:
        return theme.palette.brand.main;
      default:
        return theme.palette.primary.light;
    }
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginTop: "5px" }}
        onClick={() => alertClickHandler(alert.participantId)}
      >
        <Box display="flex" justifyContent="start" alignItems="stretch" mt={2}>
          <Box
            sx={{
              width: "10px",
              height: "100px",
              backgroundColor: getBorderColorBasedOnAlertCode(),
              borderRadius: "5px",
            }}
          ></Box>
          <Box pl={1}>
            <Box>
              <Typography
                fontWeight={theme.typography.fontWeightBold}
                fontSize={theme.typography.h6.fontSize}
                color={theme.palette.secondary.dark}
                variant="headlineSmall"
              >
                Test approval pending
                {!alert.status && (
                  <Circle sx={{ height: 10 }} color={"error"} />
                )}
              </Typography>
            </Box>
            <Box>
              <Typography
                color={theme.palette.textMain.dark2}
                variant="bodyMedium"
              >
                <b>{alert.participantName}</b> submitted a test validation
                request
              </Typography>
            </Box>
            <Box>
              <Typography
                fontSize={theme.typography.caption.fontSize}
                textTransform={"uppercase"}
                color={theme.palette.icon.dark}
                variant="bodyMedium"
              >
                {alert.day}
              </Typography>
            </Box>
          </Box>
        </Box>
        <ChevronRight />
      </Box>
    </>
  );
};

export default ApprovalRequestItem;
